import { parseEnv } from './parseEnv'

export type { Env } from './parseEnv'

// process.env.X must stay literal so Next inlines the NEXT_PUBLIC_* values at build time.
export const env = parseEnv({
  NEXT_PUBLIC_GOOGLE_MANAGER_ID: process.env.NEXT_PUBLIC_GOOGLE_MANAGER_ID,
  NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
  NEXT_PUBLIC_GOOGLE_MANAGER_ID_ISHA: process.env.NEXT_PUBLIC_GOOGLE_MANAGER_ID_ISHA,
  NEXT_PUBLIC_GOOGLE_ANALYTICS_ID_ISHA: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID_ISHA,
  NEXT_PUBLIC_GOOGLE_ADS_ID_ISHA: process.env.NEXT_PUBLIC_GOOGLE_ADS_ID_ISHA,
  NEXT_PUBLIC_GOOGLE_MANAGER_ID_MEDLEVE: process.env.NEXT_PUBLIC_GOOGLE_MANAGER_ID_MEDLEVE,
  NEXT_PUBLIC_META_PIXEL_ID: process.env.NEXT_PUBLIC_FACEBOOK_PIXEL,
  NEXT_PUBLIC_FACEBOOK_PIXEL: process.env.NEXT_PUBLIC_FACEBOOK_PIXEL,
  NEXT_PUBLIC_USER_TOKEN: process.env.NEXT_PUBLIC_USER_TOKEN,
  NEXT_PUBLIC_IUGU_ACCOUNT_ID: process.env.NEXT_PUBLIC_IUGU_ACCOUNT_ID,
  NEXT_PUBLIC_OPEN_JWT_SECRET: process.env.NEXT_PUBLIC_OPEN_JWT_SECRET,
  NEXT_PUBLIC_GTM_CUSTOM_SRC: process.env.NEXT_PUBLIC_GTM_CUSTOM_SRC,
  NEXT_PUBLIC_GTM_CUSTOM_ID: process.env.NEXT_PUBLIC_GTM_CUSTOM_ID,
  NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
  NODE_ENV: process.env.NODE_ENV
})
